import type { SystemStyleObject } from '@hover/blueprint';
import { useTheme } from '@hover/blueprint';
import type { Breakpoints } from '@hover/blueprint/foundation';

/**
 * Helper for creating `max-width` media queries based on system breakpoints.
 * Responsive style props use `min-width` and there are a few cases where we
 * need to use `max-width` queries to responsively override styles set by Framer
 * Motion animations
 *
 * @param breakpoint
 *
 * @returns function that accepts a style object and returns a media query
 */
export const useMaxWidthQuery = (breakpoint: keyof Breakpoints) => {
  const { breakpoints } = useTheme();

  return (styles: SystemStyleObject) => ({
    [`@media (max-width: ${breakpoints[breakpoint]})`]: styles,
  });
};
